export const CREDERE_LABEL = 'Credere';
export const CREDERE_VALUE = '#474E66';

export const CUSTOM_LABEL = 'Cor personalizada';
export const CUSTOM_VALUE = 'picker';

export const COLORS = [
  { label: CUSTOM_LABEL, value: CUSTOM_VALUE },
  { label: CREDERE_LABEL, value: CREDERE_VALUE },

  { label: 'Carvão', value: '#000000' },
  { label: 'Grafite', value: '#767676' },
  { label: 'Ruby', value: '#CC0000' },
  { label: 'Amazônia', value: '#008948' },
  { label: 'Safira', value: '#003082' },
  { label: 'Cobalto', value: '#0238F4' },
  { label: 'Oceano', value: '#1173B7' },
  { label: 'Areia', value: '#CD9834' },
  { label: 'Ouro', value: '#FFBA00' },
];
